import { CARRIER_NAMES_REQUIRE_EXTERNAL_GUIDE } from '../constants/shippingMethods'
import { isPickupDelivery } from './isPickupDelivery'

export const CNC_DISABLED_STORE_IDS = [18877, 158]

export const ELIGIBLE_CNC_STATUSES = [
    'initial', 'unpaid', 'pending', 'processing', 'error',
    'backorder', 'picking', 'packing', 'holded',
]

/**
 * Frontend gate for the "convert to Click & Collect" offer.
 *
 *   order.status in ELIGIBLE_CNC_STATUSES        (pre-label lifecycle)
 *   && !order.is_click_and_collect               (not already converted)
 *   && shipping country MX && warehouse MX        (MX-only rollout)
 *   && shipping.zip_code non-blank                (the pickup search needs it; masked and
 *                                                  numeric values pass; never throws on a non-string)
 *   && store not blacklisted
 *   && shipping_method present                   (platform layer 1: nil method is ineligible)
 *   && delivery_type not Pickup (warehouse pickup)  (platform layer 1 via delivery_type)
 *   && carrier not external-guide                 (platform layer 1)
 *
 * These mirror the parts of ShippingMethod.cnc_original_eligibility the tracking
 * payload can support. The payload does NOT carry shipping_method.shipping_type
 * (order_tracking_api_controller whitelists id, delivery_type, carrier_name,
 * is_active, shipping_name), so the national-shipping check stays server-side
 * with the price layer; the pickup-list screen handles both rejections. Within what
 * the payload does carry, delivery_type is the payload's proxy for the platform's
 * non-national check: delivery_type Pickup corresponds to the platform's pickup
 * shipping_type (e.g. "Recoger en Almacén"), so it is excluded here the same way.
 * A present shipping_method with no carrier_name still passes (fail open; the
 * server is the authority on carrier eligibility).
 */
export const isCncUpsellEligible = (order) =>
    ELIGIBLE_CNC_STATUSES.includes(order?.status) &&
    order?.is_click_and_collect !== true &&
    order?.shipping?.country?.toUpperCase() === 'MX' &&
    !!String(order?.shipping?.zip_code ?? '').trim() &&
    order?.store?.warehouses?.[0]?.country?.toUpperCase() === 'MX' &&
    !CNC_DISABLED_STORE_IDS.includes(order?.store?.id) &&
    order?.shipping_method != null &&
    !isPickupDelivery(order?.shipping_method) &&
    !CARRIER_NAMES_REQUIRE_EXTERNAL_GUIDE.includes(order?.shipping_method?.carrier_name)
